// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { AppModule } from './app.module';
bootstrapAppModule(AppModule);
